export const alertIndex = (code) => {
    const index = {
        // === User
        // Login
        log001: {
            active: true,
            type: 'succ',
            title: 'Identifiants corrects',
            desc: "Vous êtes bien connecté"
        },
        log002: {
            active: true,
            type: 'err',
            title: "Identifiants incorrects",
            desc: "Les identifiants sont incorrectes."
        },
        // Est admin ?
        usia001 : {
            active: false,
            type: 'succ',
            title: '',
            desc: ''
        },
        usia002: {
            active: true,
            type: 'err',
            title: 'Utilisateur non connecté',
            desc: "Veuillez vous connecter pour effectuer cette action."
        },
        usia003: {
            active: true,
            type: 'err',
            title: "Droits insuffisants",
            desc: "Vous n'avez pas les droits nécessaires pour effectuer cette action."
        },
        // Mot de passe oublié - 1
        usfo1001: {
            active: true,
            type: 'succ',
            title: "Code envoyé par mail",
            desc: "Un code vous a été envoyé par mail, vérifiez dans vos spams."
        },
        usfo1002: {
            active: true,
            type: 'err',
            title: "Informations manquantes",
            desc: "Veuillez saisir une adresse mail."
        },
        usfo1003: {
            active: true,
            type: 'err',
            title: "Une erreur est survenue",
            desc: "L'adresse mail n'est liée à aucun utilisateur."
        },
        // Mot de passe oublié - 2
        usfo2001: {
            active: true,
            type: 'succ',
            title: "Mot de passe modifié",
            desc: "Votre mot de passe a bien été modifié."
        },
        "usfo2002-1": {
            active: true,
            type: 'err',
            title: "Informations manquantes",
            desc: "Veuillez saisir le code envoyé par mail."
        },
        "usfo2002-2": {
            active: true,
            type: 'err',
            title: "Informations manquantes",
            desc: "Veuillez saisir votre adresse mail."
        },
        "usfo2002-3": {
            active: true,
            type: 'err',
            title: "Informations manquantes",
            desc: "Veuillez saisir un nouveau mot de passe."
        },
        "usfo2002-4": {
            active: true,
            type: 'err',
            title: "Informations manquantes",
            desc: "Veuillez saisir la confirmation du mot de passe."
        },
        usfo2003: {
            active: true,
            type: 'err',
            title: "Une erreur est survenue",
            desc: "Les mots de passe ne correspondent pas."
        },
        usfo2004: {
            active: true,
            type: 'err',
            title: "Adresse mail introuvable",
            desc: "Cette adresse mail n'est lié à aucune demande de nouveau mot de passe."
        },
        usfo2005: {
            active: true,
            type: 'err',
            title: "Code incorrect",
            desc: "Le code ne correspond pas au code envoyé par mail."
        },
        // Création d'un utilisateur
        ussa001: {
            active: true,
            type: 'succ',
            title: "Compte créé !",
            desc: "Votre compte a été créé avec succès !"
        },
        "ussa002-1": {
            active: true,
            type: 'err',
            title: "Information manquante",
            desc: "Veuillez saisir une adresse mail."
        },
        "ussa002-2": {
            active: true,
            type: 'err',
            title: "Information manquante",
            desc: "Veuillez saisir un mot de passe."
        },
        "ussa002-3": {
            active: true,
            type: 'err',
            title: "Information manquante",
            desc: "Veuillez saisir la confirmation du mot de passe."
        },
        ussa003: {
            active: true,
            type: 'err',
            title: "Adresse mail déjà utilisée",
            desc: "Cette adresse mail est déjà associée à un compte."
        },
        ussa004: {
            active: true,
            type: 'err',
            title: "Données incorrectes",
            desc: "Les mots de passe ne correspondent pas."
        },
        ussa005: {
            active: true,
            type: 'err',
            title: "Information manquante",
            desc: "Veuillez accepter le règlement pour pouvoir vous inscrire."
        },
        // === Gallerie
        // Liste
        gali001: {
            active: false,
            type: 'succ',
            title: '',
            desc: ''
        },
        // Détails d'une gallerie
        gade001: {
            active: false,
            type: 'succ',
            title: '',
            desc: ''
        },
        // Enregistrement gallerie
        gaad001: {
            active: true,
            type: 'succ',
            title: "Image créée",
            desc: "L'image a bien été intégrée à la galerie."
        },
        "gaad001-1": {
            active: true,
            type: 'succ',
            title: "Image modifiée",
            desc: "L'image a bien été modifiée."
        },
        gaad002: {
            active: true,
            type: 'err',
            title: 'Utilisateur non connecté',
            desc: "Veuillez vous connecter pour effectuer cette action."
        },
        gaad003: {
            active: true,
            type: 'err',
            title: "Information manquante",
            desc: "Veuillez importer une image."
        },
        gaad004: {
            active: true,
            type: 'err',
            title: "Droits insuffisants",
            desc: "Vous n'avez pas les droits suffisants pour effectuer cette action."
        },
        // Supprimer une image de la gallerie
        gasu001: {
            active: true,
            type: 'succ',
            title: "Image supprimée",
            desc: "L'image a bien été supprimée de la galerie"
        },
        gasu002: {
            active: true,
            type: 'err',
            title: 'Utilisateur non connecté',
            desc: "Veuillez vous connecter pour effectuer cette action."
        },
        gasu003: {
            active: true,
            type: 'err',
            title: "Droits insuffisants",
            desc: "Vous n'avez pas les droits suffisants pour effectuer cette action."
        },
        // Liker une gallerie
        gali001: {
            active: false,
            type: 'succ',
            title: '',
            desc: ''
        },
        gali002: {
            active: true,
            type: 'err',
            title: "Utilisateur non connecté",
            desc: "Veuillez vous connecter pour effectuer cette action."
        },
        // === Contact
        // Envoyer un message
        tcse001: {
            active: false,
            type: 'succ',
            title: '',
            desc: ''
        },
        tcse002: {
            active: true,
            type: 'err',
            title: 'Information manquantes',
            desc: 'Veuillez saisir un message.'
        },
        // Enregistrement des coordonnées
        tcco001: {
            active: true,
            type: 'succ',
            title: 'Coordonnées enregistrées !',
            desc: "Vos coordonnées ont bien été enregistrées."
        },
        "tcco002-1": {
            active: true,
            type: 'err',
            title: 'Informations manquantes',
            desc: "Veuillez saisir votre adresse mail."
        },
        "tcco002-2": {
            active: true,
            type: 'err',
            title: 'Informations manquantes',
            desc: "Veuillez saisir votre prénom."
        },
        // Envoyer un message (admin)
        tcsa001: {
            active: false,
            type: 'succ',
            title: '',
            desc: ''
        },
        tcsa002: {
            active: true,
            type: 'err',
            title: "Utilisateur non connecté",
            desc: "Veuillez vous connecter pour effectuer cette action."
        },
        tcsa003: {
            active: true,
            type: 'err',
            title: "Droits insuffisants",
            desc: "Vous n'avez pas les droits suffisants pour effectuer cette action."
        },
        tcsa004: {
            active: true,
            type: 'err',
            title: 'Informations manquantes',
            desc: "Veuillez saisir un message."
        },
        // Liste des messages
        tcli001: {
            active: false,
            type: 'succ',
            title: '',
            desc: ''
        },
        // Liste des messages (admin)
        tcla001: {
            active: false,
            type: 'succ',
            title: '',
            desc: ''
        },
        tcla002: {
            active: true,
            type: 'err',
            title: "Utilisateur non connecté",
            desc: "Veuillez vous connecter pour effectuer cette action."
        },
        tcla003: {
            active: true,
            type: 'err',
            title: "Droits insuffisants",
            desc: "Vous n'avez pas les droits suffisants pour effectuer cette action."
        },
        // Liste des messages (admin accueil)
        tcli001: {
            active: false,
            type: 'succ',
            title: '',
            desc: ''
        },
        // Liste des messages (admin)
        tclh001: {
            active: false,
            type: 'succ',
            title: '',
            desc: ''
        },
        tclh002: {
            active: true,
            type: 'err',
            title: "Utilisateur non connecté",
            desc: "Veuillez vous connecter pour effectuer cette action."
        },
        tclh003: {
            active: true,
            type: 'err',
            title: "Droits insuffisants",
            desc: "Vous n'avez pas les droits suffisants pour effectuer cette action."
        },
        // Nombre de message non lu user
        tcnblu001: {
            active: false,
            type: 'succ',
            title: '',
            desc: ''
        },
        // Nombre de message non lu admin
        tcnbluad001: {
            active: false,
            type: 'succ',
            title: '',
            desc: ''
        },
        tcnbluad002: {
            active: true,
            type: 'err',
            title: "Utilisateur non connecté",
            desc: "Veuillez vous connecter pour effectuer cette action."
        },
        tcnbluad003: {
            active: true,
            type: 'err',
            title: "Droits insuffisants",
            desc: "Vous n'avez pas les droits suffisants pour effectuer cette action."
        },
        // Sauvegarder newsletter
        nlsa001: {
            active: true,
            type: 'succ',
            title: "Inscription réalisée",
            desc: "Votre inscription pour la newsletter s'est effectuée avec succès."
        },
        "nlsa002-1": {
            active: true,
            type: 'err',
            title: "Informations manquantes",
            desc: "Veuillez saisir votre prénom.",
        },
        "nlsa002-2": {
            active: true,
            type: 'err',
            title: "Informations manquantes",
            desc: "Veuillez saisir votre adresse mail.",
        },
        nlsa003: {
            active: true,
            type: 'err',
            title: "Adresse mail déjà exisante",
            desc: "Cette adresse mail est déjà inscrite sur la liste de diffusion des newsletters."
        },
        // Envoi des newsletter
        nlse001: {
            active: true,
            type: 'succ',
            title: "Newsletter envoyée",
            desc: "La newsletter a été envoyée avec succès !"
        },
        nlse002: {
            active: true,
            type: 'err',
            title: "Utilisateur non connecté",
            desc: "Veuillez vous connecter pour effectuer cette action."
        },
        nlse003: {
            active: true,
            type: 'err',
            title: "Droits insuffisants",
            desc: "Vous n'avez pas les droits suffisants pour effectuer cette action."
        },
        nlse004: {
            active: true,
            type: 'err',
            title: "Informations manquantes",
            desc: "Veuillez saisir du contenu."
        },
        // === Actualités
        // Save message
        blsa001: {
            active: true,
            type: "succ",
            title: "Article enregistré",
            desc: "L'article a bien été créé."
        },
        "blsa001-1": {
            active: true,
            type: 'succ',
            title: "Article modifié",
            desc: "L'article a bien été modifié."
        },
        blsa002: {
            active: true,
            type: 'err',
            title: "Utilisateur non connecté",
            desc: "Veuillez vous connecter pour effectuer cette action."
        },
        blsa003: {
            active: true,
            type: 'err',
            title: "Droits insuffisants",
            desc: "Vous n'avez pas les droits suffisants pour effectuer cette action."
        },
        "blsa004-1": {
            active: true,
            type: 'err',
            title: "Informations manquantes",
            desc: "Veuillez saisir un titre."
        },
        "blsa004-2": {
            active: true,
            type: 'err',
            title: "Informations manquantes",
            desc: "Veuillez saisir une description."
        },
        "blsa004-3": {
            active: true,
            type: 'err',
            title: "Informations manquantes",
            desc: "Veuillez saisir le code de la vidéo youtube."
        },
        // Supprimer une actu
        blde001: {
            active: true,
            type: 'succ',
            title: "Article supprimé",
            desc: "L'article a bien été supprimé."
        },
        blde002: {
            active: true,
            type: 'err',
            title: "Utilisateur non connecté",
            desc: "Veuillez vous connecter pour effectuer cette action."
        },
        blde003: {
            active: true,
            type: 'err',
            title: "Droits insuffisants",
            desc: "Vous n'avez pas les droits suffisants pour effectuer cette action."
        },
        // Détails d'une actu
        bldet001: {
            active: false,
            type: 'succ',
            title: '',
            desc: ''
        },
        // Liste des actus
        blli001: {
            active: false,
            type: 'succ',
            title: '',
            desc: ''
        },
        // Like actu
        bllk001: {
            active: false,
            type: 'succ',
            title: '',
            desc: ''
        },
        bllk002: {
            active: true,
            type: 'err',
            title: "Utilisateur non connecté",
            desc: "Veuillez vous connecter pour effectuer cette action."
        },
        // Vue actu
        blvu001: {
            active: false,
            type: 'succ',
            title: '',
            desc: ''
        },
        // === Identité
        // Mise à jour 
        idse001: {
            active: true,
            type: 'succ',
            title: "Identité mise à jour",
            desc: "L'identité a bien été mise à jour."
        },
        idse002: {
            active: true,
            type: 'err',
            title: "Utilisateur non connecté",
            desc: "Veuillez vous connecter pour effectuer cette action."
        },
        idse003: {
            active: true,
            type: 'err',
            title: "Droits insuffisants",
            desc: "Vous n'avez pas les droits suffisants pour effectuer cette action."
        },
        "idse004-1": {
            active: true,
            type: 'err',
            title: 'Informations manquantes',
            desc: "Veuillez importer un logo."
        },
        "idse004-2": {
            active: true,
            type: 'err',
            title: 'Informations manquantes',
            desc: "Veuillez saisir un nom."
        },
        "idse004-3": {
            active: true,
            type: 'err',
            title: 'Informations manquantes',
            desc: "Veuillez saisir une description."
        },
        "idse004-4": {
            active: true,
            type: 'err',
            title: 'Informations manquantes',
            desc: "Veuillez saisir un slug."
        },
        // Obtention de l'identité
        idge001: {
            active: false,
            type: 'succ',
            title: '',
            desc: ''
        },
        // === Parcs 
        // Liste parc 
        pali001: {
            active: false,
            type: 'succ',
            title: '',
            desc: ''
        },
        // Détails parc 
        padt001: {
            active: false,
            type: 'succ',
            title: '',
            desc: ''
        },
        // Sauvegarder un parc
        'pasa001-1': {
            active: true,
            type: 'succ',
            title: "Parc créé",
            desc: "Le parc a été créé avec succès."
        },
        "pasa001-2": {
            active: true,
            type: 'succ',
            title: "Parc modifié",
            desc: "Le parc a été modifié avec succès."
        },
        pasa002: {
            active: true,
            type: 'err',
            title: "Utilisateur non connecté",
            desc: "Veuillez vous connecter pour effectuer cette action."
        },
        pasa003: {
            active: true,
            type: 'err',
            title: "Droits insuffisants",
            desc: "Vous n'avez pas les droits suffisants pour effectuer cette action."
        },
        "pasa004-1": {
            active: true,
            type: 'err',
            title: 'Informations manquantes',
            desc: "Veuillez indiquer l'id du parc."
        },
        // Supprimer un parc
        pade001: {
            active: true,
            type: 'succ',
            title: "Parc supprimé",
            desc: "Le parc a bien été supprimé."
        },
        pade002: {
            active: true,
            type: 'err',
            title: "Utilisateur non connecté",
            desc: "Veuillez vous connecter pour effectuer cette action."
        },
        pade003: {
            active: true,
            type: 'err',
            title: "Droits insuffisants",
            desc: "Vous n'avez pas les droits suffisants pour effectuer cette action."
        },
        wapa001: {
            active: false,
            type: 'succ',
            title: '',
            desc: ''
        },
        // === Attractions
        // Liste des attractions 
        rili001: {
            active: false,
            type: 'succ',
            title: '',
            desc: ''
        },
        // Liste des attractions par parc
        ripa001: {
            active: false,
            type: 'succ',
            title: '',
            desc: ''
        },
        // Détails attraction 
        ridt001: {
            active: false,
            type: 'succ',
            title: '',
            desc: ''
        },
        // Sauvegarder une attraction
        'risa001-1': {
            active: true,
            type: 'succ',
            title: "Attraction créée",
            desc: "L'attraction a été créée avec succès."
        },
        "risa001-2": {
            active: true,
            type: 'succ',
            title: "Attraction modifiée",
            desc: "L'attraction a été modifiée avec succès."
        },
        risa002: {
            active: true,
            type: 'err',
            title: "Utilisateur non connecté",
            desc: "Veuillez vous connecter pour effectuer cette action."
        },
        risa003: {
            active: true,
            type: 'err',
            title: "Droits insuffisants",
            desc: "Vous n'avez pas les droits suffisants pour effectuer cette action."
        },
        "risa004-1": {
            active: true,
            type: 'err',
            title: 'Informations manquantes',
            desc: "Veuillez indiquer l'id de l'attraction."
        },
        // Supprimer une attraction
        ride001: {
            active: true,
            type: 'succ',
            title: "Attraction supprimée",
            desc: "L'attraction a bien été supprimée."
        },
        ride002: {
            active: true,
            type: 'err',
            title: "Utilisateur non connecté",
            desc: "Veuillez vous connecter pour effectuer cette action."
        },
        ride003: {
            active: true,
            type: 'err',
            title: "Droits insuffisants",
            desc: "Vous n'avez pas les droits suffisants pour effectuer cette action."
        },
        riqu001: {
            active: false,
            type: 'succ',
            title: "",
            desc: ""
        },
        wari001: {
            active: false,
            type: 'succ',
            title: '',
            desc: ''
        },
        wtge001: {
            active: false,
            type: 'succ',
            title: '',
            desc: ''
        },
        wahi001: {
            active: false,
            type: 'succ',
            title: '',
            desc: ''
        },
        wafi001: {
            active: false,
            type: 'succ',
            title: '',
            desc: ''
        },
        usdt001: {
            active: false,
            type: 'succ',
            title: '',
            desc: ''
        },
        ip001: {
            active: false,
            type: 'succ',
            title: '',
            desc: ''
        },
        nlnb001: {
            active: false,
            type: 'succ',
            title: '',
            desc: ''
        },
        // Activer/Désactiver une attraction
        rien001: {
            active: true,
            type: 'succ',
            title: "Attraction modifiée",
            desc: "L'attraction a bien été modifiée."
        },
        rien002: {
            active: true,
            type: 'err',
            title: "Utilisateur non connecté",
            desc: "Veuillez vous connecter pour effectuer cette action."
        },
        rien003: {
            active: true,
            type: 'err',
            title: "Droits insuffisants",
            desc: "Vous n'avez pas les droits suffisants pour effectuer cette action."
        },
        // Activer/Désactiver un parc
        paen001: {
            active: true,
            type: 'succ',
            title: "Parc modifié",
            desc: "Le parc a bien été modifié."
        },
        paen002: {
            active: true,
            type: 'err',
            title: "Utilisateur non connecté",
            desc: "Veuillez vous connecter pour effectuer cette action."
        },
        paen003: {
            active: true,
            type: 'err',
            title: "Droits insuffisants",
            desc: "Vous n'avez pas les droits suffisants pour effectuer cette action."
        },
        // ================= CODE ====================
        // === Project
        // Liste des projets
        coprli001: {
            active: false,
            type: 'succ',
            title: "",
            desc: ""
        },
        coprli002: {
            active: true,
            type: 'err',
            title: "Utilisateur non connecté",
            desc: "Veuillez vous connecter pour effectuer cette action."
        },
        coprli003: {
            active: true,
            type: 'err',
            title: "Droits insuffisants",
            desc: "Vous n'avez pas les droits suffisants pour effectuer cette action."
        },
        // Détail d'un projet
        coprdt001: {
            active: false,
            type: 'succ',
            title: "",
            desc: ""
        },
        coprdt002: {
            active: true,
            type: 'err',
            title: "Utilisateur non connecté",
            desc: "Veuillez vous connecter pour effectuer cette action."
        },
        coprdt003: {
            active: true,
            type: 'err',
            title: "Droits insuffisants",
            desc: "Vous n'avez pas les droits suffisants pour effectuer cette action."
        },
        // Créer un projet
        coprsa001: {
            active: true,
            type: 'succ',
            title: "Projet enregistré",
            desc: "Le projet a bien été enregistré."
        },
        coprsa002: {
            active: true,
            type: 'err',
            title: "Utilisateur non connecté",
            desc: "Veuillez vous connecter pour effectuer cette action."
        },
        coprsa003: {
            active: true,
            type: 'err',
            title: "Droits insuffisants",
            desc: "Vous n'avez pas les droits suffisants pour effectuer cette action."
        },
        // Supprimer un projet
        coprdl001: {
            active: true,
            type: 'succ',
            title: "Projet supprimé",
            desc: "Le projet a bien été supprimé"
        },
        coprdl002: {
            active: true,
            type: 'err',
            title: "Utilisateur non connecté",
            desc: "Veuillez vous connecter pour effectuer cette action."
        },
        coprdl003: {
            active: true,
            type: 'err',
            title: "Droits insuffisants",
            desc: "Vous n'avez pas les droits suffisants pour effectuer cette action."
        },
        // === Dossier
        // Liste des dossiers
        cofoli001: {
            active: false,
            type: 'succ',
            title: "",
            desc: ""
        },
        cofoli002: {
            active: true,
            type: 'err',
            title: "Utilisateur non connecté",
            desc: "Veuillez vous connecter pour effectuer cette action."
        },
        cofoli003: {
            active: true,
            type: 'err',
            title: "Droits insuffisants",
            desc: "Vous n'avez pas les droits suffisants pour effectuer cette action."
        },
        // Détails d'un dossier
        cofodt001: {
            active: false,
            type: 'succ',
            title: "",
            desc: ""
        },
        cofodt002: {
            active: true,
            type: 'err',
            title: "Utilisateur non connecté",
            desc: "Veuillez vous connecter pour effectuer cette action."
        },
        cofodt003: {
            active: true,
            type: 'err',
            title: "Droits insuffisants",
            desc: "Vous n'avez pas les droits suffisants pour effectuer cette action."
        },
        // Ajouter un dossier
        cofosa001: {
            active: true,
            type: 'succ',
            title: "Dossier enregistré",
            desc: "Le dossier a bien été enregistré."
        },
        cofosa002: {
            active: true,
            type: 'err',
            title: "Utilisateur non connecté",
            desc: "Veuillez vous connecter pour effectuer cette action."
        },
        cofosa003: {
            active: true,
            type: 'err',
            title: "Droits insuffisants",
            desc: "Vous n'avez pas les droits suffisants pour effectuer cette action."
        },
        // Supprimer un dossier
        cofoli001: {
            active: true,
            type: 'succ',
            title: "Dossier supprimé",
            desc: "Le dossier a bien été supprimé."
        },
        cofoli002: {
            active: true,
            type: 'err',
            title: "Utilisateur non connecté",
            desc: "Veuillez vous connecter pour effectuer cette action."
        },
        cofoli003: {
            active: true,
            type: 'err',
            title: "Droits insuffisants",
            desc: "Vous n'avez pas les droits suffisants pour effectuer cette action."
        },
        // === Fichier
        // Détail d'un fichier
        cofldt001: {
            active: false,
            type: 'succ',
            title: "",
            desc: ""
        },
        cofldt002: {
            active: true,
            type: 'err',
            title: "Utilisateur non connecté",
            desc: "Veuillez vous connecter pour effectuer cette action."
        },
        cofldt003: {
            active: true,
            type: 'err',
            title: "Droits insuffisants",
            desc: "Vous n'avez pas les droits suffisants pour effectuer cette action."
        },
        // Ajout d'un fichier
        coflsa001: {
            active: true,
            type: 'succ',
            title: "Fichier enregistré",
            desc: "Le fichier a bien été enregistré."
        },
        coflsa002: {
            active: true,
            type: 'err',
            title: "Utilisateur non connecté",
            desc: "Veuillez vous connecter pour effectuer cette action."
        },
        coflsa003: {
            active: true,
            type: 'err',
            title: "Droits insuffisants",
            desc: "Vous n'avez pas les droits suffisants pour effectuer cette action."
        },
        // Supprimer un fichier
        cofldl001: {
            active: true,
            type: 'succ',
            title: "Fichier supprimé",
            desc: "Le fichier a bien été supprimé."
        },
        cofldl002: {
            active: true,
            type: 'err',
            title: "Utilisateur non connecté",
            desc: "Veuillez vous connecter pour effectuer cette action."
        },
        cofldl003: {
            active: true,
            type: 'err',
            title: "Droits insuffisants",
            desc: "Vous n'avez pas les droits suffisants pour effectuer cette action."
        },
    }

    return index[code];
}